import { motion } from "framer-motion";
import { useEffect } from "react";
const features = [
  {
    title: "Diverse Global Contributors",
    desc: "Real-world cultural diversity.",
    color: "from-cyan-500 to-blue-500",
  },
  {
    title: "Human-in-the-Loop Quality Control",
    desc: "Verified accuracy.",
    color: "from-emerald-500 to-teal-500",
  },
  {
    title: "Transparency & Ethics",
    desc: "Ethical sourcing, privacy-first.",
    color: "from-purple-500 to-pink-500",
  },
  {
    title: "Scalability & Speed",
    desc: "Delivering from pilots to large-scale projects.",
    color: "from-orange-400 to-amber-500",
  },
];

export default function WhyPrisuExperts() {
  //  useEffect(() => {
  //         window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //       }, []);
  
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-black via-gray-900 to-black text-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl font-extrabold mb-8 text-white font-orbitron tracking-tight">
          Human + Data Expertise for AI You Can Trust
        </h2>

        <p className="text-lg text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed font-raleway">
          We combine advanced tools with our global contributor network to deliver datasets that are accurate, culturally aware, and contextually relevant.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left">
          {features.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className={`p-6 rounded-xl shadow-lg bg-gradient-to-r ${item.color} cursor-pointer`}
            >
              <motion.h3
                className="text-lg font-bold mb-3"
                animate={{ scale: [1, 1.05, 1] }}
                transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
              >
                {item.title}
              </motion.h3>
              <p className="text-sm leading-relaxed text-gray-100">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
